import {
  faBus,
  faCircleLeft,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Steps } from "antd";
import "./styles.css";
import car2 from "../../assets/car2.png";
import Heading from "../../Components/Heading/Heading";
import ServicesSection from "../../Page/Home/ServicesSection";
import AllServices from "../../Page/Home/AllServices";

function HomeDashboard() {
  return (
    <>
      <Heading heading="ما نقدم" />
      <ServicesSection />

      <AllServices />
    </>
  );
}

export default HomeDashboard;
